"use strict";
export var LayoutModes = /* @__PURE__ */ ((LayoutModes2) => {
  LayoutModes2["Default"] = "default";
  LayoutModes2["Neat"] = "neat";
  LayoutModes2["NeatPro"] = "neat2";
  return LayoutModes2;
})(LayoutModes || {});
